import React, { memo, useRef } from "react";
import cn from "classnames";
import { H2, Text } from "@ui/Text";
import { Status } from "./Status";
import {
  Header,
  headerActions,
  HeaderDescription,
  headerStatus,
  headerTitle,
  headerWithScrollAnimation,
} from "./_styles/Header";
import { useProject } from "../../../../../../../api/useProjects";
import { PrintableInfo } from "../../../../utils/print";
import { useScrollAnimation } from "./hook/useScrollAnimation";
import { useDashboard } from "../../../../hook/api/dashboard";

export const DashboardReadonlyHeader = memo(
  ({
    className,
    projectId,
    dashboardId,
    children,
    enableScrollAnimation = true,
  }: React.PropsWithChildren<{
    className?: string;
    projectId: string;
    dashboardId: string;
    enableScrollAnimation?: boolean;
  }>) => {
    const root = useRef<HTMLDivElement>(null);
    const { dashboard } = useDashboard(projectId, dashboardId);
    const project = useProject(projectId);

    useScrollAnimation(root, enableScrollAnimation);

    if (!dashboard || !project) return null;

    return (
      <Header
        ref={root}
        className={cn(className, { [headerWithScrollAnimation]: enableScrollAnimation })}
      >
        <Status
          className={headerStatus}
          projectId={projectId}
          dashboardId={dashboardId}
          published={dashboard.published}
          readonly={dashboard.readonly}
          username={dashboard.createdByUserName ?? null}
        />
        <div className={headerActions}>{children}</div>
        <PrintableInfo
          userName={dashboard.createdByUserName ?? undefined}
          projectName={project.name}
          projectSiteId={project.siteId ?? undefined}
          projectTypeId={project.typeId ?? undefined}
        />
        <H2 className={headerTitle}>{dashboard.title}</H2>
        {dashboard.description && (
          <Text className={HeaderDescription}>{dashboard.description}</Text>
        )}
      </Header>
    );
  },
);
